import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import Icon from "@material-ui/core/Icon";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Tooltip from "@material-ui/core/Tooltip";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import PropTypes from "prop-types";
import React from "react";
import { withRouter } from "react-router";

import { globalHistory } from "../history";

class LeftMenuItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 0,
      openItemsLevel2: [], // Mảng lưu trữ trạng thái mở của từng mục trong menu tầng 2
      activeMenuLevel1: false,
    };
  }
  componentDidMount() {
    this.history = globalHistory();
  }
  // state = {
  //   selectedIndex: 0,
  //   open: false,
  // };

  handleListItemClick = (event, index) => {
    this.setState({ selectedIndex: index });
  };

  handleClick = (index, item) => {
    // Thêm index để xác định mục nào được nhấp vào
    this.setState((state) => {
      const openItemsLevel2 = [...state.openItemsLevel2];
      openItemsLevel2[index] = !openItemsLevel2[index]; // Đảo ngược trạng thái mở của mục được nhấp vào
      return { openItemsLevel2 };
    });

    if (item.items?.length > 0) {
      return;
    } else {
      this.history.push(`${process.env.REACT_APP_PATH}${item.path}`);
    }
  };
  render() {
    const pathname = this.props.location.pathname;
    const { title, subItems, handleOpenMenuLevel1, id } = this.props;
    const { openItemsLevel2 } = this.state;
    let color = "none";
    if (this.state.activeMenuLevel1) {
      color = "inset 0.1875rem 0 0 #fcb71e";
    }
    return (
      <div onClick={this.props.handleOpenMenu}>
        {this.props.item.value !== "dashboard" ? (
          <Tooltip title={title} placement="right">
            <ListItem
              button
              onClick={() => {
                this.setState((state) => ({
                  activeMenuLevel1: !state.activeMenuLevel1,
                }));
                handleOpenMenuLevel1(id);
              }}
              style={{ boxShadow: color }}>
              <ListItemIcon>
                <Icon style={{ color: "#fff" }}>{this.props.iconString}</Icon>
              </ListItemIcon>
              <ListItemText
                primary={`${title}`}
                style={{ whiteSpace: "nowrap", color: "#fff" }}
                className="title"
              />
              {/* {this.state.open && this.props.openMenu ? ( */}
              {this.props.openMenuLevel1 ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
          </Tooltip>
        ) : (
          <Tooltip title={"Tổng quan"} placement="right">
            <ListItem
              disableTouchRipple
              button
              selected={pathname === `${process.env.REACT_APP_PATH}`}
              onClick={() => {
                this.this.history.push(`${process.env.REACT_APP_PATH}`);
              }}>
              <ListItemIcon>
                <Icon style={{ color: "#fff" }}>{this.props.iconString}</Icon>
              </ListItemIcon>
              <ListItemText primary="Tổng quan" className="title" />
            </ListItem>
          </Tooltip>
        )}
        <Collapse in={this.props.openMenuLevel1} timeout="auto">
          {subItems.map((item, key) => {
            return (
              <React.Fragment key={key}>
                {item.type !== "divider" ? (
                  <React.Fragment>
                    {/* Mục của tầng 2 */}
                    <ListItem
                      disableTouchRipple
                      button
                      selected={
                        pathname === `${process.env.REACT_APP_PATH}${item.path}`
                      }
                      onClick={() => this.handleClick(key, item)}
                      style={{ marginLeft: 8 }}>
                      <ListItemIcon>
                        <Icon style={{ color: "#fff" }}>{item.icon}</Icon>
                      </ListItemIcon>
                      <ListItemText
                        primary={`${item.title}`}
                        style={{ color: "#fff" }}
                        className="title"
                      />
                      {/* icon */}
                      {item?.items?.length ? (
                        openItemsLevel2[key] ? (
                          <ExpandLess />
                        ) : (
                          <ExpandMore />
                        )
                      ) : null}
                    </ListItem>

                    {/* Xử lý các mục của tầng 3 */}
                    {item.items && (
                      <Collapse
                        in={openItemsLevel2[key]}
                        timeout="auto"
                        style={{ marginLeft: "20px" }}>
                        {item.items.map((subItem, subKey) => (
                          <React.Fragment key={subKey}>
                            {subItem.type !== "divider" ? (
                              <ListItem
                                disableTouchRipple
                                button
                                selected={
                                  pathname ===
                                  `${process.env.REACT_APP_PATH}${subItem.path}`
                                }
                                onClick={() => {
                                  this.history.push(
                                    `${process.env.REACT_APP_PATH}${subItem.path}`
                                  );
                                }}
                                // style={{ marginLeft: 16 }}
                              >
                                <ListItemIcon>
                                  <Icon style={{ color: "#fff" }}>
                                    {subItem.icon}
                                  </Icon>
                                </ListItemIcon>
                                <ListItemText
                                  primary={`${subItem.title}`}
                                  style={{ color: "#fff" }}
                                  className="title"
                                />
                              </ListItem>
                            ) : null}
                            {subItem.type == "divider" ? <Divider /> : null}
                          </React.Fragment>
                        ))}
                      </Collapse>
                    )}
                  </React.Fragment>
                ) : null}
                {item.type == "divider" ? <Divider /> : null}
              </React.Fragment>
            );
          })}
        </Collapse>
      </div>
    );
  }
}

LeftMenuItems.propTypes = {
  title: PropTypes.string,
  subItems: PropTypes.array,
  iconString: PropTypes.string,
  handleOpenMenu: PropTypes.func,
  handleOpenMenuLevel1: PropTypes.func,
  id: PropTypes.number,
};

export default withRouter(LeftMenuItems);
